import { render, staticRenderFns } from "./TransportRoute.vue?vue&type=template&id=1b92c068&scoped=true&"
import script from "./TransportRoute.vue?vue&type=script&lang=js&"
export * from "./TransportRoute.vue?vue&type=script&lang=js&"
import style0 from "./TransportRoute.vue?vue&type=style&index=0&id=1b92c068&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b92c068",
  null
  
)

export default component.exports